<template>
  <div class="main-page">
    <Header
      v-if="
        $route.name !== 'Login' &&
        $route.name !== 'StudyAbroad' &&
        $route.name !== 'ScholarshipForm' &&
        $route.name !== 'NavRegister' &&
        $route.name !== 'StudyAbroadFair' &&
        $route.name !== 'StudyAbroadFair1' &&
        $route.name !== 'StudyAbroadFair2' &&
        $route.name !== 'StudyAbroadFair3' &&
        $route.name !== 'SolapurFair' &&
        $route.name !== 'PuneFair' &&
        $route.name !== 'IeltsDoc' &&
        $route.name !== 'MultiStepForm' &&
        $route.name !== 'ThankYouPage' &&
        ![
          'MBBS',
          'AmbatturChennaiMBBS',
          'BandraMBBS',
          'BelapurMBBS',
          'CoimbatoreMBBS',
          'DeccanPuneMBBS',
          'HubballiMBBS',
          'KarveRoadPuneMBBS',
          'KolkataOfficeMBBS',
          'LowerParelMBBS',
          'MiraRoadMBBS',
          'OMRChennaiMBBS',
          'PimpliSaudagarMBBS',
          'RaipurMBBS',
          'SolapurHarshadaMBBS',
          'SolapurOfficeMBBS',
          'ThaneMBBS',
          'VashiMBBS',
          'VimanNagarMBBS',
          'KalyanMBBS',
          'SangliMBBS',
        ].includes($route.name)
      "
    />
    <div id="app">
      <router-view></router-view>
      <!-- {{$route}} -->
    </div>
    <Footer
      v-if="
        $route.name !== 'Login' &&
        $route.name !== 'StudyAbroad' &&
        $route.name !== 'ScholarshipForm' &&
        $route.name !== 'NavRegister' &&
        $route.name !== 'StudyAbroadFair' &&
        $route.name !== 'StudyAbroadFair1' &&
        $route.name !== 'StudyAbroadFair2' &&
        $route.name !== 'StudyAbroadFair3' &&
        $route.name !== 'ThaneFranchise' &&
        $route.name !== 'GujratFranchise' &&
        $route.name !== 'MiraRoadFranchise' &&
        $route.name !== 'LowerParelFranchise' &&
        $route.name !== 'RaipurFranchise' &&
        $route.name !== 'SolapurFranchise' &&
        $route.name !== 'NaviMumbaiFranchise' &&
        $route.name !== 'KarnatakaFranchise' &&
        $route.name !== 'DubaiFranchise' &&
        $route.name !== 'KuwaitFranchise' &&
        $route.name !== 'DeccanFranchise' &&
        $route.name !== 'KarveRoadFranchise' &&
        $route.name !== 'PimpleFranchise' &&
        $route.name !== 'CoimbatoreFranchise' &&
        $route.name !== 'KolkataFranchise' &&
        $route.name !== 'OMRChennaiFranchise' &&
        $route.name !== 'IeltsDoc' &&
        $route.name !== 'StudyAbroadFair4' &&
        $route.name !== 'SolapurFair' &&
        $route.name !== 'PuneFair' &&
        $route.name !== 'ThankYouPage' &&
        $route.name !== 'MultiStepForm' &&
        $route.name !== 'IeltsDemo' &&
        ![
          'MBBS',
          'AmbatturChennaiMBBS',
          'BandraMBBS',
          'BelapurMBBS',
          'CoimbatoreMBBS',
          'DeccanPuneMBBS',
          'HubballiMBBS',
          'KarveRoadPuneMBBS',
          'KolkataOfficeMBBS',
          'LowerParelMBBS',
          'MiraRoadMBBS',
          'OMRChennaiMBBS',
          'PimpliSaudagarMBBS',
          'RaipurMBBS',
          'SolapurHarshadaMBBS',
          'SolapurOfficeMBBS',
          'ThaneMBBS',
          'VashiMBBS',
          'VimanNagarMBBS',
          'KalyanMBBS',
          'SangliMBBS',
        ].includes($route.name)
      "
    />
  </div>
</template>

<script>
import Vue from "vue";
import VueRouter from "vue-router";
import VueCalendly from "vue-calendly";
import Header from "@/components/partials/Header.vue";
import Footer from "@/components/partials/Footer.vue";
import { mapActions } from "vuex";

Vue.use(VueCalendly);

export default {
  metaInfo: {
    title:
      "Best Overseas Education Consultants | Consultancy For Foreign Education",
    htmlAttrs: {
      lang: "en-US",
    },
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "Aliff Overseas is the ultimate solution for students who want to join top-ranking international universities without wasting time or spending a fortune. Visit the website today!",
      },
      { name: "viewport", content: "width=device-width, initial-scale=1" },
    ],
  },
  components: {
    Header,
    Footer,
  },
  name: "app",
  created() {
    let elem = document.getElementById("loader");
    elem.remove();
  },
  methods: {
    ...mapActions(["onGetBlogs"]),
  },
  computed: {},
  beforeMount() {
    this.onGetBlogs();
  },
};
</script>



// WEBPACK FOOTER //
// src/App.vue